import { StyleSheet } from 'react-native';

import { ADDONS_MY_PROFILE_DISPLAY_TYPES } from '../../../Utils/Enums';

export default StyleSheet.create({
  titleStyle: {
    height: 25,
    width: 181.25,
    marginBottom: 10.42,
  },
  subtitleStyle: {
    height: 16.67,
    width: 83.33,
    marginBottom: 18.75,
  },
  recommendedCardStyle: {
    width: '100%',
    height: 37.5,
    marginVertical: 35,
    marginTop: 10,
    borderRadius: 6.2,
  },
  addOnsCardCircle: {
    width: 41.67,
    height: 41.67,
    borderRadius: 20.8,
    marginRight: 16.67,
    marginTop: 12.5,
  },
  addOnsCardSquare: {
    marginTop: 12.5,
    width: '100%',
    height: 12,
  },
  addOnsCardUsersLine: {
    marginTop: 20,
    width: 83.33,
    height: 12.5,
    marginLeft: 58.5,
  },
  displayChange: displayType => ({
    width: displayType === ADDONS_MY_PROFILE_DISPLAY_TYPES.MY_ADDONS ? 128.1 : 105,
    height: 16.7,
    marginTop: 3,
  }),
});
